(function () {
  if (window.__imageWithTextInit) return;
  window.__imageWithTextInit = true;

  const calculateAndSetCustomPadding = () => {
    const header = document.querySelector('header');
    if (!header) return;
    const headerStyles = window.getComputedStyle(header);
    const padLeft = parseFloat(headerStyles.paddingLeft) || 0;
    const margLeft = parseFloat(headerStyles.marginLeft) || 0;
    const offSet = padLeft + margLeft;
    document.documentElement.style.setProperty('--image-with-text-offset', `${offSet}px`);
  };

  document.addEventListener('DOMContentLoaded', calculateAndSetCustomPadding);
  window.addEventListener('resize', calculateAndSetCustomPadding);
})();

